import IHcValidator from './IHcValidator';
import IHcValidationResult from './IHcValidationResult';
import HcValidationResult from './HcValidationResult';
import IHcValidationDefinition from './IHcValidationDefinition';
import IHcValidationResults from './IHcValidationResults';

export default class HcValidator implements IHcValidator {
    
    validationResult: IHcValidationResult = new HcValidationResult();
    validationDefinitions: IHcValidationDefinition[] = [];
    isOnBlur: boolean = false;
    isOnUpdate: boolean = false;

    constructor(validationDefinition?: IHcValidationDefinition | IHcValidationDefinition[], onUpdate: boolean = false, onBlur: boolean = false) {
        validationDefinition && (((validationDefinition instanceof Array) && 
            (this.validationDefinitions = validationDefinition)) || this.validationDefinitions.push(validationDefinition as IHcValidationDefinition));

        this.isOnUpdate = onUpdate;
        this.isOnBlur = onBlur;
    }

    get isValid(): boolean {
        return this.validationResult.isValid;
    }

    get message(): string {
        return this.validationResult.message;
    }

    validate(value: any): IHcValidationResults {
        
        let allValidations: IHcValidationResult[] = new Array<IHcValidationResult>();

        this.clearValidationResult();
        
        // let validationDefinitionsIterator = 0;        
        // while (this.isValid && validationDefinitionsIterator < this.validationDefinitions.length) {
        //     this.validationResult = this.validationDefinitions[validationDefinitionsIterator].validate(value);
        //     validationDefinitionsIterator++;
        // }

        let wasInvalid = false;

        this.validationDefinitions.forEach(rule=>{
            let validationResult = rule.validate(value);
            allValidations.push(validationResult);
            !validationResult.isValid&&!wasInvalid&&(wasInvalid=true,this.validationResult=validationResult);
        });
        
        return {
            isValid: this.isValid,
            validationResults: allValidations
        };
    }

    validateOnBlur(value: any): boolean | IHcValidationResults {
        return this.isOnBlur && this.validate(value);
    }

    validateOnUpdate(value: any): boolean | IHcValidationResults {
        return this.isOnUpdate && this.validate(value);
    }

    private clearValidationResult(): void {
        this.validationResult = new HcValidationResult();
    }
}